<template>
  <div>
    <div id="container">
      <app-header :now=1 :gi=true></app-header>
      <div class="container_box" style="padding: 0px">
        <router-view></router-view>
        <div id="left_menu">
          <div class="logo">
            <img src="/static/img/logo.png"/>
            <span>智达云服务平台</span>
          </div>
        </div>
        <!--<div id="map"></div>-->
        <div class="GI">
          <div class="searchGI">
<!--            <div class="search_box">-->
<!--              <div v-for="item in search" :class='["search_options_box"]'>-->
<!--                <span style="color: #0b2f54">{{item.title}}</span>-->
<!--                <img src="/static/img/select.png" alt="">-->
<!--                <select class="select">-->
<!--                  <option v-for="item2 in item.select" :value='item2.option'>{{item2.option}}</option>-->
<!--                </select>-->
<!--              </div>-->
<!--              <div class="search_btn_box">-->
<!--                <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="el-icon-search"></span>筛选</button>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div id="map" style="width: 100%;height: 100%;background: #FFFFFF;position: absolute;top:0"></div>
          <div class="data_display information_box light_border">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="data_title">数据显示</div>
            <div class="main">
              <div v-for="item in main" class="data_main">
                <div v-bind:style="[{background:'url('+item.icon+') no-repeat center center'}]"></div>
                <div>
                  <p v-bind:style="[{color:item.color}]">{{item.num}}<span style="color: #00fafe">{{item.unit}}</span>
                  </p>
                  <span>{{item.name}}</span>
                </div>
              </div>

            </div>
          </div>

          <div class="light_win information_box light_border" >
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <img src="/static/img/light.png">
            <div class="part part1">
              <div class="circle"></div>
              <div class="line"></div>
              <div class="part_title">智慧照明</div>
              <div class="icon_box"><span class="icon-1"></span></div>
            </div>
            <div class="part part2">
              <div class="circle"></div>
              <div class="line"></div>
              <div class="part_title">智慧安防</div>
              <div class="icon_box"><span class="icon-3"></span></div>
            </div>
            <div class="part part3">
              <div class="circle"></div>
              <div class="line"></div>
              <div class="part_title">智能音箱</div>
              <div class="icon_box"><span class="icon-6"></span></div>
            </div>
            <div class="part part4">
              <div class="circle"></div>
              <div class="line"></div>
              <div class="part_title">一键报警</div>
              <div class="icon_box"><span class="icon-7"></span></div>
            </div>
            <div class="part part5">
              <div class="icon_box"><span class="icon-2"></span></div>
              <div class="part_title">环境监测</div>
              <div class="line" style="margin: 0 0 0 20px"></div>
              <div class="circle"></div>
            </div>
            <div class="part part6">
              <div class="icon_box"><span class="icon-4"></span></div>
              <div class="part_title">无线WiFi</div>
              <div class="line" style="margin: 0 0 0 20px"></div>
              <div class="circle"></div>
            </div>
            <div class="part part7">
              <div class="icon_box"><span class="icon-5"></span></div>
              <div class="part_title">信息发布</div>
              <div class="line" style="margin: 0 0 0 20px"></div>
              <div class="circle"></div>
            </div>
            <div class="part part8">
              <div class="icon_box"><span class="icon-8"></span></div>
              <div class="part_title">充电桩</div>
              <div class="line" style="margin: 0 0 0 20px"></div>
              <div class="circle"></div>
            </div>
            <div class="part part9">
              <div class="circle"></div>
              <div class="line"></div>
              <div class="part_title">RFID监测</div>
              <div class="icon_box"><span class="icon-7"></span></div>
            </div>
            <div class="part part10">
              <div class="circle"></div>
              <div class="line"></div>
              <div class="part_title">5G网络</div>
              <div class="icon_box"><span class="icon-7"></span></div>
            </div>


            <!--            灯功能数据-->
            <div class="light_function information_box light_border">
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
              <div class="right_title">灯功能数据</div>
              <div class="main" style="height: calc(100% - 70px)">
                <div class="light_main">
                  <div>路灯状态：</div>
                  <div v-if="light.status=='0'">关闭</div>
                  <div v-else-if="light.status=='1'">开启</div>
                  <div v-else>—&nbsp;—</div>
                </div>
                <div class="light_main">
                  <div>路灯色温：</div>
                  <div v-if="lightStatus=='1'">5000 K</div>
                  <div v-else >—&nbsp;—</div>
                </div>
                <div class="light_main">
                  <div>光效：</div>
                  <div>120 lm/w</div>
                </div>
                <div class="light_main">
                  <div>显色指数：</div>
                  <div>75</div>
                </div>
                <div class="light_main">
                  <div>WIFI状态：</div>
                  <div v-if="wifiTep=='1'">正常</div>
                  <div v-else-if="wifiTep=='0'">离线</div>
                  <div v-else>—&nbsp;—</div>
                </div>
                <div class="light_main">
                  <div>信息屏状态：</div>
                  <div v-if="ledTep=='1'">在线</div>
                  <div v-else-if="ledTep=='0'">离线</div>
                  <div v-else>—&nbsp;—</div>
                </div>
                <div class="light_main">
                  <div>主控板温度：</div>
                  <div v-if="tep=='1'">{{viewing.temperature}} ℃</div>
                  <div v-else>—&nbsp;—</div>
                </div>
              </div>
            </div>

            <!--            显示屏数据-->
            <div class="viewing_screen information_box light_border">
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
              <div class="right_title">显示屏数据</div>
              <div class="main" style="height: calc(100% - 70px);">
                <div class="light_main">
                  <div>显示屏状态：</div>
                  <div v-if="ledTep=='1'">在线</div>
                  <div v-else="ledTep=='0'">离线</div>
                </div>
                <div class="light_main">
                  <div>显示屏亮度：</div>
                  <div>{{ledbrightness}}%</div>
                </div>
                <div class="light_main">
                  <div>显示屏色温：</div>
                  <div>{{ledData.colortemp}}K</div>
                </div>
                <div class="light_main" >
                  <div>播放时长：</div>
                  <div>2时32分</div>
                </div>
                <div class="light_main" >
                  <div>定时关闭：</div>
                  <div>4时52分</div>
                </div>
              </div>
            </div>


            <!--充电桩弹窗-->
<!--            <div class="charging_pile children">-->
<!--              <div class="win_box information_box light_border">-->
<!--                <div class="border_top_left"></div>-->
<!--                <div class="border_top_right"></div>-->
<!--                <div class="border_bottom_left"></div>-->
<!--                <div class="border_bottom_right"></div>-->
<!--                <div class="right_title" style="background-position-x: 100px;">充电桩</div>-->
<!--                <div class="box_content">-->
<!--                  <div class="charge_pic"><img src="/static/img/charge_pic.png"></div>-->
<!--                  <div class="charge_msg">-->
<!--                    <img src="/static/img/lightning_car.png">-->
<!--                    <div class="switch">-->
<!--                      <span>-->
<!--                        开关：<el-switch-->
<!--                        v-model="Switch"-->
<!--                        active-color="#13ce66"-->
<!--                        inactive-color="#ff4949">-->
<!--                        </el-switch>-->
<!--                      </span>-->
<!--                      <span>状态：<span style="color: #ec1313">占用</span></span>-->
<!--                    </div>-->
<!--                    <div class="output_msg">-->
<!--                      <p>输出电压：<span>215V</span></p>-->
<!--                      <p>输出电流：<span>32V</span></p>-->
<!--                      <p>已充电量：<span>(30kw-h)</span></p>-->
<!--                    </div>-->
<!--                    <div class="charge_btn">-->
<!--                      <button>取消</button>-->
<!--                      <button>确定</button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            无限WiFi弹窗-->
            <div class="wifi_win children">
              <div class="win_box information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="right_title" style="background-position-x: 130px;">无线WiFi</div>
                <div class="wifi_content">
                  <span>上行速度：<span>800kb/秒</span></span>
                  <span>下行速度：<span>1000kb/秒</span></span>
                  <span>当前在线人数：<span>16人</span></span>
                </div>
              </div>
            </div>

            <!--            环境监测-->
            <div class="environment children">
              <div class="environment_box information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="right_title" style="background-position-x: 130px;">环境监测</div>
                <div class="environment_content">
                  <span>温度：<span>{{viewing.temperature}} ℃</span></span>
                  <span>湿度：<span>{{viewing.humidity}} RH</span></span>
                  <span>噪声：<span>{{viewing.noise }} dB</span></span>
                  <span>PM2.5：<span>{{viewing.haze  }} μg/m³</span></span>
                </div>
              </div>
            </div>
            <!--智慧安防-->
            <div class="security children" style="display: block">
              <div class="security_box information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="right_title" style="background-position-x: 130px;">智慧安防</div>
                <div class="security_content">
                  <div class="video_box" id="videoBox">

                  </div>
<!--                  <div class="control_btn" hidden>-->
<!--                    <div class="direction_btn">-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/1.png') no-repeat center center;background-size:15px 15px;" @click="left_top()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/2.png') no-repeat center center;background-size:15px 15px;" @click="top()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/3.png') no-repeat center center;background-size:15px 15px;" @click="right_top()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/4.png') no-repeat center center;background-size:15px 15px;" @click="left_center()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/5.png') no-repeat center center;background-size:15px 15px;" @click="center_center()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/6.png') no-repeat center center;background-size:15px 15px;" @click="right_center()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/7.png') no-repeat center center;background-size:15px 15px;" @click="left_bottom()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/8.png') no-repeat center center;background-size:15px 15px;" @click="center_bottom()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/9.png') no-repeat center center;background-size:15px 15px;" @click="right_bottom"></button>-->
<!--                    </div>-->
<!--                    <div class="direction_btn">-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/+.png') no-repeat center center;background-size:15px 15px;" @click="magnify()"></button>-->
<!--                      <button>倍数</button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/-.png') no-repeat center 9px;background-size:15px 2px;" @click="shrink()"></button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/+.png') no-repeat center center;background-size:15px 15px;" @click="focus_add()"></button>-->
<!--                      <button>变焦</button>-->
<!--                      <button-->
<!--                        style="background: url('/static/img/btn/-.png') no-repeat center 9px;background-size:15px 2px;" @click="focus_reduce()"></button>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
            <div class="msg children" style="display: block;height: 350px;width: 345px;">
              <div class="msg_box information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="right_title" style="background-position-x: 130px;">信息发布</div>
                <div class="msg_content">
                  <div class="msg_box">
<!--                    <div>-->
<!--                      <video class="video-js" controls width="146" height="328">-->
<!--                        <source src="" type="rtmp/flv">-->
<!--                      </video>-->
<!--                      <video class="video-js" controls width="146" height="328">-->
<!--                        <source src="" type="rtmp/flv">-->
<!--                      </video>-->
<!--                    </div>-->
                    <img src="" alt="">
                    <div class="msg_list" >
                      <h1>节目列表</h1>
                      <table style="color: white">
                        <thead>
                        <tr>
                          <th></th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in ledList">
                          <td style="width: 240px;">{{item.name}}</td>
                          <td>
                            <span v-if="item.state=='0'">未播放</span>
                            <span v-else-if="item.state=='2'">正在播放</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="loudSpeaker children" style="display: block">
              <div class="msg_box information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="right_title" style="background-position-x: 130px;">智能音箱</div>
                <div class="loudSpeaker_content">
                  <div class="loudSpeaker_box">
                    <h1>当前播放节目</h1>
                    <div class="loudSpeaker_list" >
                      <h1>节目列表</h1>
                      <table style="color: white">
                        <thead>
                        <tr>
                          <th></th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in soundList">
                          <td style="width: 240px;">{{item.name}}</td>
                          <td>
                            <span v-if="item.state=='0'">未播放</span>
                            <span v-else-if="item.state=='2'">正在播放</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--            一键报警-->
            <div class="police children">
              <div class="police_box information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="right_title" style="background-position-x: 130px;">一键报警</div>
                <div  class="police_content">
                  <img src="/static/img/police.png">
                  <p >状态：
                      <span v-if="this.deviceData.status==0">离线</span>
                      <span v-else="this.deviceData.status==1">在线</span>
                  </p>
                </div>
              </div>
            </div>

            <!--智慧照明-->
            <div class="illumination children">
              <div class="illumination_box information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="right_title" style="background-position-x: 130px;">智慧照明</div>
                <div class="illumination_content">
                  <div class="output_msg">
                    <p>开关：<el-switch
                      v-model="Switch"
                      active-color="#13ce66"
                      inactive-color="#a4a4a5" @change="openClose($event)" >
                    </el-switch></p>
                    <p style="height: 58px">
                      <span style="float: left;height: 38px;line-height: 38px;margin-right: 10px">亮度：</span>
                      <el-slider
                       :show-tooltip="false"
                      v-model="brightnessData"
                      :step="1"
                      :min="1"
                      :max="5"
                      :marks="marks"
                      style="width: 70%;float: left">
                    </el-slider>
                    </p>
                    <p>状态：
                      <span v-if="light.status=='0'" style="color: #ec1313">关闭</span>
                      <span v-else="light.status=='1'" span style="color: #21b868">开启</span>
                    </p>
                  </div>
                  <div class="charge_btn" style="display: flex;align-items: center;justify-content: center">
                    <button>取消</button>
                    <button @click="brightness_sbt()">确定</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div id="mask" @click="close()"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import HelloWorld from './components/HelloWorld'
  import Header from "./Header";
  import $ from 'jquery'

  export default {
    name: 'GI',
    components: {
      "app-header": Header,
    },
    computed: {
      mapstyle() {
        return this.$store.state.mapstyle
      }
    },
    data() {
      return {

        // search: [
        //   {
        //     title: '项目',
        //     select: [
        //       {option: "全部"},
        //       {option: "安平项目"},
        //     ]
        //   }, {
        //     title: '群组',
        //     select: [
        //       {option: "全部"},
        //       {option: "安平群组"},
        //     ]
        //   }, {
        //     title: '小组',
        //     select: [
        //       {option: "全部"},
        //       //{option: ""},
        //     ]
        //   },
        // ],
        point:[],
        city: '石家庄',
        map: '',
        selectedId:"",
        putonstatus:[],
        lightStatus:'',
        ledTep:'',
        wifiTep:'',


        qwerqwre: 2,
        main: [
          {
            icon: "/static/img/GIS_icon1.png",
            num: "1",
            name: "项目总数",
            color: "#ffffff",
            unit: "个",
          }, {
            icon: "/static/img/GIS_icon2.png",
            num: "32",
            name: "终端总数",
            color: "#ffffff",
            unit: "个",
          }, {
            icon: "/static/img/GIS_icon3.png",
            num: "0",
            name: "异常报警数",
            color: "#dc1010",
            unit: "个",
          }, {
            icon: "/static/img/GIS_icon4.png",
            num: "2402",
            name: "总耗电量",
            color: "#ffffff",
            unit: "度",
          },
        ],
        videourl:"",

        light: {},//[
           // {name: "路灯状态", msg: this.type},
           // {name: "路灯色温", msg: "6000K"},
           // {name: "光效", msg: "120lm/w"},
           // {name: "显色指数", msg: "75"},
           // {name: "WIFI状态", msg: "正常"},
           // {name: "信息屏状态", msg: "正常"},
           // {name: "大气温度", msg: "26℃"},
        //],
        viewing: {},
        //   [
        //   {name: "显示屏状态", msg: "正常"},
        //   {name: "显示屏亮度", msg: "50%"},
        //   {name: "显示屏色温", msg: "6000K"},
        //   {name: "播放时长", msg: "2时32分"},
        //   {name: "定时关闭", msg: "4时52分"},
        // ],
        brightness: false,//亮度
        brightnessData: 0,
        ledbrightness:'',
        brightnessSelect: [
          {value: '1', label: '20%'},
          {value: '2', label: '40%'},
          {value: '3', label: '60%'},
          {value: '4', label: '80%'},
          {value: '5', label: '100%'},
        ],
        // 单灯开关
        Open: false,
        Close: false,
        ledList:[],
        soundList:[],
        ledData:{},
        deviceData:[],
        pileData:{},
        sensorData:{},
        videoData:{},
        soundData:{},
        wifiData:{},
        wifiDatastatus:'',
        video_id:'',
        Switch:false,
        Lamp: false,
        tep:'',
        tap:'',
        //listData:[],
        marks: {
          1:{
            style: {
              color: '#ffffff'
            },
            label: this.$createElement('strong', '20%')
          },
          2:{
            style: {
              color: '#ffffff'
            },
            label: this.$createElement('strong', '40%')
          },
          3:{
            style: {
              color: '#ffffff'
            },
            label: this.$createElement('strong', '60%')
          },
          4:{
            style: {
              color: '#ffffff'
            },
            label: this.$createElement('strong', '80%')
          },
          5:{
            style: {
              color: '#ffffff'
            },
            label: this.$createElement('strong', '100%')
          },
        },
        videoElement:"",
        myPlayer1:null
      }
    },
    created: function () {

      //this.AllData();
      this.InitLeftMenu();
      //this.DeviceDataList();
      // this.drawMap();
      $(function () {
        $('.part').click(function () {
          $(this).addClass('now').siblings().removeClass('now')
        })
      })
    },
    methods: {
      addClassFun: function (index) {
        this.qwerqwre = index;
      },
      close: function () {
        $(".light_win").fadeOut(200);
        $(".light_win .children").fadeOut(200);
        //$('.part').css('display', 'none');
        $('.part').removeClass("now");
        $("#mask").css('z-index', '-1');
      },
      // drawMap:function () {

      // },
      // //报警状态
      // DeviceDataList:function(){
      //   fetch("/api/v1/alarm/DeviceDataList", {
      //     method: 'post',
      //       body: JSON.stringify({
      //       "project_id": "f899dfb4a9094ac48fbb27b64021d5e1",
      //     })
      //   })
      //     .then(result => {
      //       return result.json();//解析流
      //     })
      //     .then(data => {
      //       this.deviceData = data.data;
      //       this.drawMap();
      //       console.log(this.table_data)
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      // },

      //安防摄像头控制
      security_open:function(id,url) {
        this.video_1 = url;
        this.video_id = id;
      },
      InitLeftMenu:function () {
        this.$emit('getMessage', '2','0');
      },
      // open:function(id,url){
      //   this.video_1 = url;
      //   this.video_id = id;
      // },
      left_top: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:4,
          }),
          method: 'post',
        })
      },
      top: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:0,
          }),
          method: 'post',
        })
      },
      right_top: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:6,
          }),
          method: 'post',
        })
      },
      left_center: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:2,
          }),
          method: 'post',
        })
      },
      center_center: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:6,
          }),
          method: 'post',
        })
      },
      right_center: function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:3,
          }),
          method: 'post',
        })
      },
      left_bottom:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:5,
          }),
          method: 'post',
        })
      },
      center_bottom:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:1,
          }),
          method: 'post',
        })
      },
      right_bottom:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:7,
          }),
          method: 'post',
        })
      },
      magnify:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:8,
          }),
          method: 'post',
        })
      },
      shrink:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:9,
          }),
          method: 'post',
        })
      },
      focus_add:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:11,
          }),
          method: 'post',
        })
      },
      focus_reduce:function () {
        fetch("/api/v1/camera/CameraPtz", {
          headers:{
            "Content-type": "application/json",
            'Accept': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({
            device_serial:this.video_id,
            dw_stop:0,
            dw_ptz_command:10,
          }),
          method: 'post',
        })
      },

      //调节亮度
      brightness_sbt: function () {
        fetch("/api/v1/lamp/brightness", {
          method: 'post',
          body: JSON.stringify({
            "lamppost_id":[this.selectedId],
            brightness: this.brightnessData.toString()

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            console.log(data)
            if (data.code == "200") {
              this.message = "所选单灯调节亮度成功";
              this.brightness = !this.brightness;
              this.refresh = true;
              this.msg_show = !this.msg_show;
              alert("所选单灯调节亮度成功");
            } else {
              this.message = "操作异常，请重试";
              this.brightness = !this.brightness;
              this.msg_show = !this.msg_show;
              alert("操作异常，请重试");
            }
          })
          .catch((error) => {
            this.message = "网络连接异常，请重试";
            this.brightness = !this.brightness;
            this.msg_show = !this.msg_show;
            alert("网络连接异常，请重试");
            throw error;
          });
      },

      //开灯
      OpenLamp_sbt: function () {
        fetch("/api/v1/lamp/open", {
          method: 'post',
          body: JSON.stringify({
            "lamppost_id":[this.selectedId],
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "开灯成功";
              this.Open = !this.Open;
              this.refresh = true;
              this.msg_show = !this.msg_show;
              alert(this.message);
              this.timer = setTimeout(this.AllData, 1000);
            } else {
              this.message = "操作异常，请重试";
              this.Open = !this.Open;
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            this.message = "网络连接异常，请重试";
            this.Open = !this.Open;
            this.msg_show = !this.msg_show;
            alert(this.message);
            throw error;
          });
      },
      OpenLamp_cancel: function () {
        this.Open = !this.Open
      },
      
      //关灯
      CloseLamp_sbt: function () {
        fetch("/api/v1/lamp/close", {
          method: 'post',
          body: JSON.stringify({
            // "lamppost_id":"["+this.selectedId+"]",
            "lamppost_id":[this.selectedId],
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "关灯成功";
              this.Close = !this.Close;
              this.refresh = true;
              this.msg_show = !this.msg_show;
              alert(this.message);
              this.timer = setTimeout(this.AllData, 1000);
            } else {
              this.message = "操作异常，请重试";
              this.Close = !this.Close;
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            this.message = "网络连接异常，请重试";
            this.Close = !this.Close;
            this.msg_show = !this.msg_show;
            alert(this.message);
            throw error;
          });
      },
      CloseLamp_cancel: function () {
        this.Close = !this.Close
      },
      //开关灯
      openClose($event){
        if($event) {
          this.OpenLamp_sbt();
        }else {
          this.CloseLamp_sbt();
        }
        console.log($event);
      },

      //数据获取
      AllData:function(){
        fetch("/api/v1/lamppost/payload", {
          method: 'post',
          body: JSON.stringify({
            "lamppost_id":this.selectedId+"",
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          // .then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "实时数据更新成功";
              console.log(this.putonstatus);
              this.refresh = true;
              this.msg_show = !this.msg_show;
              if (this.putonstatus[0]=='1' && data.data.lamp) {
                this.light = data.data.lamp;
                this.lightStatus='1';
                //alert(this.light);
                this.brightnessData=parseInt( this.light.brightness);
                if (this.light.status == '0') {
                  this.Switch = false;
                } else if (this.light.status == '1') {
                  this.Switch = true;
                }
              }else{
                this.light = {};
                this.lightStatus='0';
              }
              if (this.putonstatus[1]=='1' && data.data.sensor){
                this.viewing = data.data.sensor;
                this.tep='1';
              }else{
                this.viewing={};
                this.tep='0';
              }
              if (this.putonstatus[2]=='1' && data.data.camera){
                this.videoData = data.data.camera;
                this.videourl = this.videoData.file_path;
                this.video_id = this.videoData.device_serial;
                var videoSource = '<video id="myPlayer1" class="video-js" controls playsInline webkit-playsinline autoplay=false width="310" height="230">' +
                  '<source id="videoSource" type="rtmp/flv" src="'+this.videourl+'">'+
                  '</video>';
                $("#videoBox").html("");
                $("#videoBox").html(videoSource);
                this.myPlayer1 = "";
                this.myPlayer1 = new EZuikit.EZUIPlayer('myPlayer1');
                // $("#myPlayer1")[0].load();
                this.myPlayer1.play();
                console.log(this.videoData.file_path);
              }else{
                this.videoData={};
              }
              if (this.putonstatus[3]=='1' && data.data.wifi){
                this.wifiData = data.data.wifi;
                this.wifiDatastatus='1';
                if(this.wifiData.is_online){
                  this.wifiTep='1';
                }else {
                  this.wifiTep='0';
                }
              }else{
                this.wifiData={};
                this.wifiDatastatus='2';
                this.wifiTep='2';
              }
              if (this.putonstatus[4]=='1' && data.data.led){
                this.ledData = data.data.led;
                this.ledbrightness=Math.round(parseInt(this.ledData.brightness)/255*100);
                this.gisled(this.ledData.id);
                if(this.ledData.is_online){
                  this.ledTep='1';
                }else {
                  this.ledTep='0';
                }
              }else{
                this.ledData={status:"2"};
                this.ledTep='2';
              }
              if (this.putonstatus[5]=='1' && data.data.sound){
                this.soundData = data.data.sound;
                this.gissound(this.soundData.id);
              }else{
                this.soundData={};
              }
              if (this.putonstatus[6]=='1' && data.data.alarm){
                this.deviceData = data.data.alarm;
                //alert(this.deviceData.status);
              }else{
                this.deviceData={};
              }
              if (this.putonstatus[7]=='1' && data.data.pile){
                this.pileData = data.data.pile;
              }else{
                this.pileData={};
              }
              /////////////////////////////////////////////////////////

              /////////////////////////////////////////////////////////
            } else {
              this.message = "数据更新异常，请重试";
              this.msg_show = !this.msg_show;
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //获取音箱
      gissound:function(device_id){
        fetch("/api/v1/sounder/gis/message", {
          method: 'post',
          body: JSON.stringify({
            "device_id": device_id,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "实时数据更新成功";
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.soundList = data.tasks;
            } else {
              this.message = "数据更新异常，请重试";
              this.msg_show = !this.msg_show;
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //获取led
      gisled:function(led_id){
        fetch("/api/v1/led/program/list", {
          method: 'post',
          body: JSON.stringify({
            "led_id": led_id+"",
            "page_start" : "0",
            "page_size" : "10",
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "实时数据更新成功";
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.ledList=data.data;
              console.log(this.data);
            } else {
              this.message = "数据更新异常，请重试";
              this.msg_show = !this.msg_show;
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //列表获取
      ListData:function(){
        fetch("/api/v1/lamppost/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "实时数据更新成功";
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.point = data.data;
              //this.Switch = data.data.lamp.status;
              this.addMarker(data.data);
            } else {
              this.message = "数据更新异常，请重试";
              this.msg_show = !this.msg_show;
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },
      addMarker:function (points) {

       for (var i = 0, pointsLen = points.length; i < pointsLen; i++) {
          //console.log(points[i].lng,points[i].lat);
          var point = new BMap.Point(points[i].lng, points[i].lat); //将标注点转化成地图上的点
          var animation = false; // 动画状态
          //添加监听事件

          this.map.enableScrollWheelZoom();
          var _this = this;

            var id = points[i].id;
            var $st = points[i].static;
            //var equipment = device_included//points[i].equipment;
            var marker;
            if ($st === "正常") {
              var myicon = new BMap.Icon("/static/img/icon/maker1.png", new BMap.Size(18, 31), {
                // 图标中央下端的尖角位置。
                anchor: new BMap.Size(9, 31),
              });
              marker = new BMap.Marker(point, {icon: myicon});
              this.map.addOverlay(marker);
            } else {
              var myicon = new BMap.Icon("/static/img/icon/maker2.png", new BMap.Size(18, 31), {
                // 图标中央下端的尖角位置。
                anchor: new BMap.Size(9, 31),
              });
              marker = new BMap.Marker(point, {icon: myicon});
              this.map.addOverlay(marker);
            }
            marker.customData = points[i];
            marker.addEventListener("click", function (e) {
              var ids = e.target.customData.id;
              var device_included = e.target.customData.device_included;
              _this.selectedId = ids;
              _this.putonstatus = device_included;
              //var equipment = device_included;
              _this.AllData();
              $(".light_win").fadeIn(200);
              $(".light_function").fadeIn();
              $("#mask").css('z-index', '999');
              // $(".part").css("display","flex");
              $(".part .part_title").removeClass("disable");
              $('.part .icon_box span').removeClass('colorDisable');
              $('.part .line').removeClass('colorDisable');
              $('.part .circle').removeClass('colorDisable');
              if (device_included[0] == 0) {
                $('.part1 .part_title').addClass('disable');
                $('.part1 .icon_box span').addClass('colorDisable');
                $('.part1 .line').addClass('colorDisable');
                $('.part1 .circle').addClass('colorDisable');
              }
              if (device_included[1] == 0) {
                $('.part5 .part_title').addClass('disable');
                $('.part5 .icon_box span').addClass('colorDisable');
                $('.part5 .line').addClass('colorDisable');
                $('.part5 .circle').addClass('colorDisable');
              }
              if (device_included[2] == 0) {
                $('.part2 .part_title').addClass('disable');
                $('.part2 .icon_box span').addClass('colorDisable');
                $('.part2 .line').addClass('colorDisable');
                $('.part2 .circle').addClass('colorDisable');
              }
              if (device_included[3] == 0) {
                $('.part6 .part_title').addClass('disable');
                $('.part6 .icon_box span').addClass('colorDisable');
                $('.part6 .line').addClass('colorDisable');
                $('.part6 .circle').addClass('colorDisable');
              }
              if (device_included[4] == 0) {
                $('.part7 .part_title').addClass('disable');
                $('.part7 .icon_box span').addClass('colorDisable');
                $('.part7 .line').addClass('colorDisable');
                $('.part7 .circle').addClass('colorDisable');
                $(".viewing_screen").hide()
              } else {
                $(".viewing_screen").fadeIn()
              }
              if (device_included[5] == 0) {
                $('.part3 .part_title').addClass('disable');
                $('.part3 .icon_box span').addClass('colorDisable');
                $('.part3 .line').addClass('colorDisable');
                $('.part3 .circle').addClass('colorDisable');
              }
              if (device_included[6] == 0) {
                $('.part4 .part_title').addClass('disable');
                $('.part4 .icon_box span').addClass('colorDisable');
                $('.part4 .line').addClass('colorDisable');
                $('.part4 .circle').addClass('colorDisable');
              }
              if (device_included[7] == 0) {
                $('.part8 .part_title').addClass('disable');
                $('.part8 .icon_box span').addClass('colorDisable');
                $('.part8 .line').addClass('colorDisable');
                $('.part8 .circle').addClass('colorDisable');
              }
              if (device_included[8] == 0) {
                $('.part9 .part_title').addClass('disable');
                $('.part9 .icon_box span').addClass('colorDisable');
                $('.part9 .line').addClass('colorDisable');
                $('.part9 .circle').addClass('colorDisable');
              }
              if (device_included[9] == 0) {
                $('.part10 .part_title').addClass('disable');
                $('.part10 .icon_box span').addClass('colorDisable');
                $('.part10 .line').addClass('colorDisable');
                $('.part10 .circle').addClass('colorDisable');
              }
            });
            $('.part1').click(function () {
              if($(this).find('.part_title').hasClass("disable")){
                return;
              }
              $('.light_win .children').hide();
              $(".illumination").fadeIn();
            });
            $('.part5').click(function () {
              if($(this).find('.part_title').hasClass("disable")){
                return;
              }
              $('.light_win .children').hide();
              $(".environment").fadeIn()
            });
            $('.part2').click(function () {
              if($(this).find('.part_title').hasClass("disable")){
                return;
              }
              $('.light_win .children').hide();
              $(".security").fadeIn()
            });
            $('.part6').click(function () {
              if($(this).find('.part_title').hasClass("disable")){
                return;
              }
              $('.light_win .children').hide();
              $(".wifi_win").fadeIn()
            });
            $('.part7').click(function () {
              if($(this).find('.part_title').hasClass("disable")){
                return;
              }
              $('.light_win .children').hide();
              $(".msg").fadeIn()
            });
            $('.part3').click(function () {
              if($(this).find('.part_title').hasClass("disable")){
                return;
              }
              $('.light_win .children').hide();
              $(".loudSpeaker").fadeIn()
            });
            $('.part4').click(function () {
              if($(this).find('.part_title').hasClass("disable")){
                return;
              }
              $('.light_win .children').hide();
              $(".police").fadeIn()
            });
            $('.part8').click(function () {
              if($(this).find('.part_title').hasClass("disable")){
                return;
              }
              $('.light_win .children').hide();
              $(".charging_pile").fadeIn()
            });

      }
    },
    },
    mounted() {
      // var player2 = new EZuikit.EZUIPlayer('myPlayer2');
      // var player3 = new EZuikit.EZUIPlayer('myPlayer3');
      //this.AllData();
      this.ListData();
      $(".light_win").hide();
      $(".light_win .children").hide();
      this.map = new BMap.Map('map');
      let point = new BMap.Point(115.534317,38.22763);// 创建点坐标
      this.map.centerAndZoom(point, 13);// 初始化地图，设置中心点坐标和地图级别
      this.map.enableScrollWheelZoom();//启用滚轮放大缩小，默认禁用。
      let points = this.point;//标记点数据
      let styleJson = this.mapstyle;
      //this.map.setMapStyleV2({styleJson: styleJson});//引入地图样式
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    }
  }
</script>

<style scoped>
  #left_menu {
    width: 270px;
    height: 78px;
    position: absolute;
    left: 0;
    top: 0;
    background: #1d4e80
  }

  #left_menu .logo {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #left_menu .logo img {
    margin-right: 10px;
  }

  #left_menu .logo span {
    font-size: 22px;
    color: #ffffff;
    font-weight: bold;
  }

  .container_box {
    background: url("/static/img/bg.jpg") no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: calc(100% - 78px);
    overflow-y: auto;
    box-sizing: border-box;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: transparent; /*滚动条的背景颜色*/
    -webkit-border-radius: 0; /*滚动条的圆角宽度*/
  }

  ::-webkit-scrollbar {
    width: 8px; /*滚动条的宽度*/
    height: 8px; /*滚动条的高度*/
  }

  ::-webkit-scrollbar-thumb { /*垂直滚动条的样式*/
    height: 50px;
    background-color: #95bee5;
    -webkit-border-radius: 4px;
    outline-offset: -2px;
  }

  ::-webkit-scrollbar-thumb:hover { /*滚动条的hover样式*/
    height: 50px;
    background-color: #00f0ff;
    -webkit-border-radius: 4px;
  }

  .now .part_title, .now .icon_box span {
    color: #00f0ff;
  }

  .now .circle, .now .line {
    background: #00f0ff;
  }

  .now .icon_box {
    background: #086988;
  }

  .GI {
    width: 100%;
    height: calc(100% - 78px);
    padding: 78px 20px 0px;
    box-sizing: border-box;
    position: absolute;
    z-index: 0;
  }

  .searchGI {
    width: 100%;
    padding: 20px 0 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    box-sizing: border-box;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
    background: transparent;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: #16518d;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
    background: #FFFFFF;
  }

  .search_options_box > img {
    position: absolute;
    right: 20px;
    top: 15px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }

  .data_display {
    position: absolute;
    left: 20px;
    top: 0;
    z-index: 9999;
    width: 250px;
    height: 390px;
  }

  .light_border {
    box-shadow: 0 0 10px #3494f6 inset;
    border: 1px solid #4b9ffc;
  }

  .information_box {
    position: relative;
    margin-top: 20px;
    float: left;
    background: #0b2f54;
  }

  .border_top_left, .border_top_right, .border_bottom_left, .border_bottom_right {
    width: 26px;
    height: 26px;
    position: absolute;
    background: url("/static/img/border.png") no-repeat center center;
  }

  .border_top_left {
    left: -2px;
    top: -2px;
  }

  .border_top_right {
    right: -2px;
    top: -2px;
    transform: rotate(90deg);
  }

  .border_bottom_left {
    left: -2px;
    bottom: -2px;
    transform: rotate(-90deg);
  }

  .border_bottom_right {
    right: -2px;
    bottom: -2px;
    transform: rotate(180deg);
  }

  .light_function {
    position: absolute;
    right: -618px;
    top: -20px;
    width: 300px;
    height: 360px;
  }

  .viewing_screen {
    width: 300px;
    height: 280px;
    position: absolute;
    right: -618px;
    top: 350px;
  }

  .data_title {
    width: 100%;
    font-size: 20px;
    color: #00f0ff;
    padding: 10px 0;
    box-sizing: border-box;
    text-align: center;
    background: url("/static/img/title_bg.png") no-repeat;
    background-position-y: center;
    background-position-x: -30px;
  }

  .main {
    width: calc(100% - 40px);
    margin: 0 20px;
    height: calc(100% - 80px);
    background: #16518d;
    border-radius: 6px;
  }

  .right_title {
    width: 100%;
    font-size: 20px;
    color: #00f0ff;
    padding: 10px 20px;
    box-sizing: border-box;
    background: url("/static/img/data_title.png") no-repeat;
    background-position-x: 150px;
    background-position-y: center;
  }

  .data_main {
    width: 100%;
    height: 76px;
    padding: 13px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .data_main > div:nth-child(1) {
    width: 30%;
    height: 32px;
    margin-left: 30px;
  }

  .data_main > div:nth-child(2) {
    width: 70%;
    display: flex;
    flex-direction: column;
    color: #00f0ff;
    margin-left: 30px;
  }

  .data_main > div:nth-child(2) > p {
    margin: 0px;
    font-size: 26px;
    font-family: '$number';
    line-height: 30px;
  }

  .data_main > div:nth-child(2) > p > span {
    font-size: 16px;
  }

  .light_main {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    height: 40px;
    display: flex;
    color: #FFFFFF;
  }

  .light_main > div:nth-child(1) {
    width: 45%;
    text-align: right;
  }

  .light_main > div:nth-child(2) {
    width: 55%;
    text-align: right;
  }

  .light_win {
    width: 580px;
    height: 616px;
    left: 400px;
    z-index: 9999;
  }

  .light_win > img {
    width: 100%;
    height: 100%;
  }

  .part {
    align-items: center;
    position: absolute;
    cursor: pointer;
    display: flex;
  }

  .circle {
    width: 7px;
    height: 7px;
    background: #00f0ff;
    border-radius: 50%;
  }

  .line {
    width: 68px;
    height: 1px;
    background: #00f0ff;
    margin-right: 20px;
  }

  .part_title {
    color: #00f0ff;
  }

  .icon_box {
    width: 30px;
    height: 30px;
    background: #355a80;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00f0ff;
    margin: 0 10px;
    border-radius: 50%;
  }

  .part1 {
    top: 80px;
    right: 30px;
  }

  .part2 {
    top: 175px;
    right: 30px;
  }

  .part3 {
    top: 310px;
    right: 30px;
  }

  .part4 {
    top: 417px;
    right: 30px;
  }

  .part5 {
    top: 150px;
    left: 30px;
  }

  .part6 {
    top: 210px;
    left: 30px;
  }

  .part7 {
    top: 340px;
    left: 30px;
  }

  .part8 {
    top: 470px;
    left: 30px;
  }

  .part9 {
    top: 375px;
    right: 30px;
  }

  .part10 {
    top: 45px;
    right: 30px;
  }

  .part10 > .line {
    width: 120px;
  }

  .charging_pile {
    width: 370px;
    height: 320px;
    position: absolute;
    left: -385px;
    bottom: 20px;
  }

  .win_box {
    width: 100%;
    height: 100%;
  }

  .box_content {
    width: 100%;
    height: calc(100% - 50px);
    padding: 0px 20px;
    box-sizing: border-box;
    display: flex;
  }

  .charge_pic {
    width: 130px;
    height: 100%;
    padding-top: 20px;
    box-sizing: border-box;
  }

  .charge_msg {
    width: calc(100% - 130px);
    height: 100%;
  }

  .switch {
    width: 100%;
    height: 40px;
    display: flex;
    padding: 10px 0;
    box-sizing: border-box;
  }

  .switch > span {
    color: #ffffff;
    line-height: 20px;
    padding-right: 15px;
    display: flex;
  }

  .output_msg > p {
    color: #ffffff;
    margin: 0px;
  }

  .charge_btn {
    width: 100%;
    height: 64px;
    padding: 20px 0;
    box-sizing: border-box;
  }

  .charge_btn > button {
    width: 60px;
    height: 24px;
    margin-right: 20px;
    border: transparent;
    outline: transparent;
    color: #ffffff;
    border-radius: 4px;
  }

  .charge_btn > button:nth-child(1) {
    background: #f2ae4d;
  }

  .charge_btn > button:nth-child(2) {
    background: #7aafeb;
  }

  .msg {
    width: 340px;
    position: absolute;
    height: 350px;
    left: -360px;
    top: -20px;
  }

  .security {
    width: 340px;
    position: absolute;
    height: 310px;
    right: -360px;
    top: 100px;
  }

  .loudSpeaker {
    width: 340px;
    position: absolute;
    height: 310px;
    right: -360px;
    top: 100px;
  }

  .loudSpeaker audio {
    margin-bottom: 10px
  }

  .loudSpeaker_box > h1 {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    color: #95bee5;
  }

  .security_box, .msg_box {
    width: 100%;
    height: 100%;
  }

  .security_content, .msg_content, .loudSpeaker_content {
    padding: 0 20px;
    box-sizing: border-box;
    height: calc(100% - 50px);
  }

  .msg_box > video, .msg_box > img {
    width: 300px;
    height: 150px;
  }

  .msg_box > img {
    display: none;
  }

  .msg_box > .msg_list, .loudSpeaker_list {
    height: 150px;
    width: 100%;
    overflow-y: hidden;
  }

  .msg_box > .msg_list > h1, .loudSpeaker_list > h1 {
    height: 40px;
    color: #95bee5;
    font-size: 16px;
    line-height: 40px;
    margin-bottom: 0;
  }

  .msg_box > .msg_list > ul, .loudSpeaker_list > ul {
    height: 90px;
    width: 100%;
    overflow-y: auto;
    border-radius: 5px;
    background: #16518d;
  }

  .msg_box > .msg_list > ul > li, .loudSpeaker_list > ul > li {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    box-sizing: border-box;
    text-align: left;
    color: #FFFFFF;
    font-size: 14px;
  }

  .wifi_win {
    width: 280px;
    position: absolute;
    height: 210px;
    left: -295px;
    bottom: 300px;
  }

  .wifi_content {
    width: 100%;
    height: calc(100% - 50px);
    padding: 20px;
    box-sizing: border-box;
  }

  .wifi_content > span {
    width: 100%;
    height: 35px;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
  }

  .environment {
    width: 280px;
    position: absolute;
    height: 235px;
    left: -295px;
    top: 100px;
  }

  .environment_box {
    width: 100%;
    height: 100%;
  }

  .environment_content {
    width: 100%;
    height: calc(100% - 50px);
    padding: 20px;
    box-sizing: border-box;
  }

  .environment_content > span {
    width: 100%;
    height: 35px;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
  }

  .police {
    width: 280px;
    position: absolute;
    height: 200px;
    right: -295px;
    bottom: 20px;
  }

  .police_box {
    width: 100%;
    height: 100%;
  }

  .police_content {
    width: 100%;
    height: calc(100% - 50px);
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .police_content > p {
    color: #ffffff;
    margin-left: 30px;
  }

  .police_content > p > span {
    color: #45db5e;
  }

  .illumination {
    width: 280px;
    height: 255px;
    position: absolute;
    right: -295px;
    top: -20px;
  }

  .illumination_box {
    width: 100%;
    height: 100%;
  }

  .illumination_content {
    width: 100%;
    height: calc(100% - 50px);
    padding: 20px;
    box-sizing: border-box;
  }


  #map {
    position: absolute;
    height: calc(100% - 78px);
    background: #FFFFFF;
    left: 0;
    top: 78px;
    z-index: 0;
  }

  .light_win .children {
    display: none;
  }

  #mask {
    width: 100%;
    height: 100%;
    background: transparent;
    position: absolute;
    top: 0;
    z-index: -1;
    left: 0;
  }

  .control_btn {
    width: 100%;
    height: 90px;
    display: flex;
    padding: 10px 0;
    box-sizing: border-box;
  }

  .control_btn > .direction_btn {
    width: 50%;
    height: 100%;
  }

  .control_btn > .direction_btn > button {
    width: 46px;
    margin: 4px 2px;
    float: left;
    box-sizing: border-box;
    border: 1px solid #FFFFFF;
    height: 20px;
    background: transparent;
    color: #FFFFFF;
    font-size: 12px;
    outline: none;
    border-radius: 4px;
  }

  .showVideo{display: block}
  .hideVideo{display: none}
  .part .part_title.disable{color:#AEB0AF;}
  .part .icon_box span.colorDisable{color:#AEB0AF;}
  .part .line.colorDisable{background:#AEB0AF;}
  .part .circle.colorDisable{background:#AEB0AF;}
</style>



// WEBPACK FOOTER //
// src/components/GI.vue